import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://suzmesayac.com';

const DEFAULT_METADATA = {
  title: 'Süzme Sayaç Hesaplama ve Elektrik Faturası Paylaştırma | suzmesayac.com',
  description: 'Ana ve süzme sayaç tüketimlerini tarife bilgileriyle hesaplayın; ortak elektrik faturasının nasıl paylaşılabileceğini anlaşılır örneklerle öğrenin.',
};

const PAGE_METADATA = {
  '/delete-account': {
    title: 'Hesap Silme | Süzme Sayaç',
    description: 'Süzme Sayaç hesabınızı ve hesabınıza bağlı verileri silme adımları.',
  },
  '/elektrik-faturasi-hesaplama': {
    title: 'Elektrik Faturası Hesaplama 2026 | Güncel Tarifeler',
    description: 'Elektrik tüketiminizi güncel tarife, kademe, dağıtım bedeli ve vergilerle hesaplayın; ayrıntılı fatura dökümünü ücretsiz görün.',
  },
  '/privacy': {
    title: 'Gizlilik Politikası | Süzme Sayaç',
    description: 'Süzme Sayaç uygulamasında kişisel verilerin ve çerezlerin nasıl işlendiğini açıklayan gizlilik politikası.',
  },
  '/support': {
    title: 'Destek ve İletişim | Süzme Sayaç',
    description: 'Süzme Sayaç hesaplama araçları ve hesabınızla ilgili destek alın, iletişim kanallarına ulaşın.',
  },
  '/terms': {
    title: 'Kullanım Koşulları | Süzme Sayaç',
    description: 'Süzme Sayaç web sitesi ve hesaplama araçları için geçerli kullanım koşulları.',
  },
};

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
}

export default function PageMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = PAGE_METADATA[pathname] || DEFAULT_METADATA;
    const pageUrl = `${SITE_URL}${pathname === '/' ? '/' : pathname}`;

    document.title = metadata.title;
    setMeta('meta[name="description"]', { name: 'description', content: metadata.description });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: metadata.title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: metadata.description });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: pageUrl });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', pageUrl);
  }, [pathname]);

  return null;
}
